import './style.scss';
import { clickableElement } from '../../../lib/clickable-element';

// BRAUCHEN WIR DAS?
// JA -> Die Abschrägung darf sich nicht verändern (es darf keine Skalierung stattfinden) - Aussage von gsi
function mediaQueries(mediaQuery: MediaQueryList) {
  document
    .querySelectorAll('.prominent-image-text-marker-element > div:first-child')
    .forEach((element: any) => {
      const elementHeight = element?.clientHeight;
      const elementWidth = element?.clientWidth;
      if (mediaQuery.matches && element) {
        const calculation = elementWidth - elementHeight / 2.99; // 2.99 is tan(α) (α = 71.56 - taken from figma)
        const polygonPoint = (100 * calculation) / elementWidth + '%';

        element.style.clipPath = `polygon(0 0, 100% 0, ${polygonPoint} 100%, 0% 100%)`;
      } else {
        element?.removeAttribute('style');
      }
    });
}

// Create a MediaQueryList object
const mediaQuery = window.matchMedia('(min-width: 768px)');

// Call listener function at run time
mediaQueries(mediaQuery);

// Attach listener function on state changes
mediaQuery.addEventListener('change', function () {
  mediaQueries(mediaQuery);
});

// clickable item
const elementItems = document.querySelectorAll(
  '.section__prominent-image-text-marker-element',
) as NodeListOf<HTMLElement>;

if (elementItems) {
  elementItems.forEach((item) => {
    clickableElement(
      item.querySelectorAll('.prominent-image-text-marker-element'),
    );
  });
}
